import React, { useEffect, useState } from 'react'
import { getAdminCategoryType } from '../../../services/adminApiService/adminCategoryType/AdminCategoryTypeApi';
import { getAdminAllSubCategory } from '../../../services/adminApiService/adminSubCategory/AdminSubCategory';
import { useCategoryFilter } from '../../../context/CategoryFilterContext';
import { Form } from "react-bootstrap";

const CategorySubCategoryFilter = ({ typeId, selectedCategory,
    placeholderText,
    setSelectedCategory,
    selectedSubCategory,
    setSelectedSubCategory,
    setCurrentPage,
    hideSubCategory = false
}) => {

    const [adminCategoryTypeData, setAdminCategoryTypeData] = useState([]);
    const [subCategorylistData, setSubCategorylistData] = useState([]);
    const [categoryId, setCategoryId] = useState([]);
    const { setSelectedSubCategoryId } = useCategoryFilter();

    const shouldHideSubCategory = hideSubCategory || typeId === "2" || placeholderText === "Institution";

    const getAdminCategoryTypeListApi = async (typeId) => {
        try {
            const response = await getAdminCategoryType(typeId);
            setAdminCategoryTypeData(response?.data);
        } catch (error) {
            console.error("Login error:", error);
        }
    };

    const getAdminSubCategoryListApi = async (categoryId) => {
        try {
            const response = await getAdminAllSubCategory(categoryId);
            setSubCategorylistData(response?.data);
        } catch (error) {
            console.error("Login error:", error);
        }
    };

    const handleAddFormChange = async (e) => {
        const { name, value } = e.target;

        setCategoryId(value);

        if (name === "category_type") {
            setSelectedCategory(value);
            if (!shouldHideSubCategory) {
                if (value) {
                    await getAdminSubCategoryListApi(value); // fetch by selected type
                } else {
                    await getAdminSubCategoryListApi(); // fetch all if no type selected
                }
            }
            setSelectedSubCategory?.('');
            setSelectedSubCategoryId?.('');
            setCurrentPage?.(1);
        }

        if (name === "sub_category_type") {
            setSelectedSubCategory?.(value);
            setSelectedSubCategoryId?.(value); // set in context
            setCurrentPage?.(1);
        }
    };

    useEffect(() => {
        getAdminCategoryTypeListApi(typeId);
    }, [typeId]);

    return (
        <>
            <div className="d-flex w-100 mb-3 ">
                <div className="">
                    <Form.Select
                        defaultValue=""
                        name="category_type"
                        onChange={handleAddFormChange}
                        id="inputState"
                        value={selectedCategory}
                        style={{ width: "100%", padding:"11px 50px 10px 11px" }}
                    >
                        <option value="">{placeholderText + " Category Type"}</option>
                        {adminCategoryTypeData?.data?.map((item) => (
                            <option key={item?.id} value={item?.id}>
                                {item?.category_name}
                            </option>
                        ))}
                    </Form.Select>
                </div>

                {!shouldHideSubCategory && (
                    <div className="mx-3">
                        <Form.Select
                            defaultValue=""
                            name="sub_category_type"
                            onChange={handleAddFormChange}
                            id="inputState"
                            value={selectedSubCategory}
                            style={{ width: "100%", padding:"11px 50px 10px 11px" }}
                        >
                            <option value="">{placeholderText + " Sub Category"}</option>
                            {subCategorylistData && Array.isArray(subCategorylistData) && subCategorylistData.map((item) => (
                                <option key={item?.id} value={item?.id}>
                                    {item?.category_name_view}
                                </option>
                            ))}
                        </Form.Select>
                    </div>
                )}
            </div>
        </>
    )
}

export default CategorySubCategoryFilter